// import Storages from '../../utils/storages';
// import Utils from '../../utils/utils';
import Vue from 'vue';
const state = {
    btnLoading: false, //按钮是否加载中
    curCtrlMode: 2, //当前控制模式
    refreshColdParamFlag: false, //是否刷新冷站系统参数
    refreshCtrlStrategyFlag: false, //是否刷新控制策略信息
    curId: '', //当前监控界面Id
    btnLoadingObj:{}, //冷站按钮loading对象
    curGroupNumber: null, //末端监控 数据列表切换保存所属分组查询数据
    curInfo:'暂无操作',
    isViewer:false,//是否是查看者
    cabDevice:true,
    endDevice:true
}
const mutations = {
    updateBtnLoading(state, data) {
        state.btnLoading = data;
      },
      setCtrlMode(state, val) {
        if (val) {
          state.curCtrlMode = val;
        }
      },
      setHasEndDevice(state, val) {
        if (val) {
          state.cabDevice = val.cabDevice;
          state.endDevice = val.endDevice;
        }
      },
      setRefreshColdParamFlag(state, val) {
        // debugger;
        // console.log('修改：setRefreshColdParamFlag :', val);
        state.refreshColdParamFlag = val;
      },
      setRefreshCtrlStrategyFlag(state, val) {
        state.refreshCtrlStrategyFlag = val;
      },
      setCurId(state, val) {
        state.curId = val;
        // console.log(val, 565656)
      },
      setBtnLoadingObj(state,payload){
        Vue.set(state.btnLoadingObj,payload.key,payload.val)
        // state.btnLoadingObj[payload.key]=payload.val;
      },
      SET_CUR_GROUNPNUMBER(state, curGroupNumber){
        state.curGroupNumber = curGroupNumber;
      },
      setCurInfo(state, val){
        state.curInfo = val;
      },
      setIsViewer(state, val){
        console.log('chakanzhe',val)
        state.isViewer = val;
      }
}
const getters={
    getBtnLoading: (state) => state.btnLoading,
    //获取当前控制模式
  getCurCtrlMode: (state) => {
    return state.curCtrlMode;
  },
  getViewer:(state)=>{
    return state.isViewer
  },
  getCabDevice:(state)=>{
    return state.cabDevice
  },
  getEndDevice:(state)=>{
    return state.endDevice
  },
  //获取冷站参数刷新标记
  getRefreshColdParamFlag: (state) => {
    return state.refreshColdParamFlag;
  },
   //获取刷新控制策略信息标记
   getRefreshCtrlStrategyFlag: (state) => {
    return state.refreshCtrlStrategyFlag;
  },
   //获取冷站简单控制按钮loading对象
   getBtnLoadingObj:(state)=>{
    return state.btnLoadingObj;
  },
  getCurGroupNumber:(state)=>{
    return state.curGroupNumber;
  },
  getCurInfo:(state)=>{
    return state.curInfo;
  }
}
const actions = {
    setGrounpNumber({ commit }, curGroupNumber) {
      commit('SET_CUR_GROUNPNUMBER', curGroupNumber)
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};